import HTMLReactParser from "html-react-parser";
import React from "react";

import { connect, ConnectedProps } from "react-redux";

import { icons } from "../../../assets/images/icons";
import { closeDialog, purchaseTool } from "../../../store/actions";

interface IProps {
  id: number;
  params: any;
  purchasable: boolean;
  question: string;
  price: number;
}

const mapDispatchToProps = (dispatch: any) => ({
  closeDialogDispatch: () => dispatch(closeDialog()),
  purchaseToolDispatch: (id: number, params: any) => dispatch(purchaseTool(id, params))
});

const connector = connect(null, mapDispatchToProps);

const PurchaseUpgrade = ({
  id,
  params,
  purchasable,
  question,
  price,
  closeDialogDispatch,
  purchaseToolDispatch
}: IProps & ConnectedProps<typeof connector>) => (<>
  <div className="dialog-content">
    <div className="text-bigger">
      {purchasable
        ? HTMLReactParser(question)
        : "Not enough credits. You can get some at your account."}
    </div>
  </div>
  <footer className="dialog-footer">
    <a
      className="btn btn-blank btn-no-width"
      onClick={closeDialogDispatch}
    >
      NO
    </a>
    <a
      href="#"
      className={`btn btn-blank btn-no-width ${purchasable ? "" : "disabled"}`}
      onClick={() => purchasable && purchaseToolDispatch(id, params)}
    >
      BUY {price} <img src={icons.credit} alt=""/>
    </a>
  </footer>
</>)

export default connector(PurchaseUpgrade);
